import { NumEditBase } from "../UI.ElementarControls/NumEditBase";
import { registerCustomElement } from "../UI.ElementarControls/Utils/CustomElementUtils";
import { Control } from "./Control";
import { EditableControl } from "./EditableControl";

export class NumEdit extends EditableControl {
    protected override _innerElement: NumEditBase;

    public get innerElement(): HTMLInputElement {
        return this._innerElement;
    }

    //#region Properties
    public override set value(val: any) {
        this.controlValue = val;
    }

    public override get value(): any {
        return this.controlValue;
    }

    public set maxLength(val: number) {
        if (val && val > 0)
            this._innerElement.maxLength = val;
    }

    public get maxLength(): number {
        return this._innerElement.maxLength;
    }

    //#region controlValue
    public get controlValue(): string {
        return this._innerElement.value;
    }

    /**
     * Nastavi hodnotu editu
     */
    public set controlValue(value: string) {
        const el = this._innerElement;

        if (this.maxLength > 0 && value && value.length > this.maxLength) {
            el.value = value.substr(0, this.maxLength);
            //this.alertOnLength();
        } else {
            el.value = value;
        }
        //this.Validate(el);
    }
    //#endregion controlValue

    /**
     * Zda má komponenta pracovat pouze s celými čísly
     */
    public set wholeNumbers(value: boolean) {
        this._innerElement.wholeNumbers = value;
    }

    public get wholeNumbers(): boolean {
        return this._innerElement.wholeNumbers;
    }

    /*
     * Funkce pro vlastní validaci.
     */
    public customValidation: (value: number) => boolean;

    /*
     * Funkce pro validaci. Pokud je naplněná vlastní validace, tak se provede ta, jinak se provádí standardní validace na předkovi.
     */
    public override validate(): boolean {
        if (this.customValidation)
            return this.customValidation(this.value);
        else
            return super.validate();
    }

    //#endregion Properties

    public override focus(): void {
        this._innerElement.focus();
    }

    protected override _constructor(): void {
        super._constructor();

        const tcont: string = this.textContent.trim();
        this.innerHTML = "";

        this._innerElement = new NumEditBase();
        this.appendChild(this._innerElement);
        this.classList.add("NumEdit");

        if (tcont.length > 0) {
            this.value = tcont;
        }
    }

    protected override connectedCallback(): void {
        super.connectedCallback();

        if (this._innerElement) {
            Control.registerEventListener(this._eventGroup, this._innerElement, "change", (e) => {
                e.stopPropagation();
                this.callEvent("change");
            });
        }
    }
}

registerCustomElement("tsc-numedit", NumEdit);
